<script setup lang="ts">
withDefaults(
  defineProps<{
    leftRose?: string
    rightRose?: string
    poster?: boolean
  }>(),
  {
    leftRose: '',
    rightRose: '',
    poster: false,
  },
)
</script>

<template>
  <section class="ornate-frame" :class="{ 'ornate-frame--poster': poster }">
    <img v-if="leftRose" class="ornate-frame__rose ornate-frame__rose--left" :src="leftRose" alt="" />
    <img v-if="rightRose" class="ornate-frame__rose ornate-frame__rose--right" :src="rightRose" alt="" />
    <i class="corner corner--tl" aria-hidden="true" />
    <i class="corner corner--tr" aria-hidden="true" />
    <i class="corner corner--bl" aria-hidden="true" />
    <i class="corner corner--br" aria-hidden="true" />
    <i class="lace lace--top" aria-hidden="true" />
    <i class="lace lace--bottom" aria-hidden="true" />
    <div class="ornate-frame__content"><slot /></div>
  </section>
</template>
